import type { SavePuntoEntregaPayload } from '@src/modules/puntos_entrega/domain/puntoEntregaModel.ts';
import type {
  RedencionBonoHeader,
  RedencionBonoParticipanteFormPayload,
} from '@src/modules/redencion_bono/domain/redencionBonoModel.ts';

/** Decoded byte estimate for a `data:` URL (base64 payload). */
export function estimateDataUrlBytes(dataUrl: string): number {
  const t = dataUrl.trim();
  if (!t.startsWith('data:')) return 0;
  const comma = t.indexOf(',');
  if (comma < 0) return 0;
  const b64 = t.slice(comma + 1);
  const padding = b64.endsWith('==') ? 2 : b64.endsWith('=') ? 1 : 0;
  return Math.max(0, Math.floor((b64.length * 3) / 4) - padding);
}

function pushIfDataUrl(urls: string[], value: string | undefined): void {
  const t = value?.trim() ?? '';
  if (t.startsWith('data:')) urls.push(t);
}

export function collectPuntoEntregaMediaDataUrls(payload: SavePuntoEntregaPayload): string[] {
  const urls: string[] = [];
  pushIfDataUrl(urls, payload.informePdf);
  for (const p of payload.participantes) {
    pushIfDataUrl(urls, p.firmaBase64);
    pushIfDataUrl(urls, p.registroFotografico);
    const a = p.acudiente;
    if (a) {
      pushIfDataUrl(urls, a.documentoFrontal);
      pushIfDataUrl(urls, a.documentoReverso);
      pushIfDataUrl(urls, a.documentoAutorizadoFrontal);
      pushIfDataUrl(urls, a.documentoAutorizadoReverso);
      pushIfDataUrl(urls, a.autorizado);
    }
  }
  return urls;
}

export function collectRedencionMediaDataUrls(
  _header: RedencionBonoHeader,
  participantes: RedencionBonoParticipanteFormPayload[],
): string[] {
  const urls: string[] = [];
  for (const p of participantes) {
    pushIfDataUrl(urls, p.firmaBase64);
    pushIfDataUrl(urls, p.registroFotografico);
  }
  return urls;
}

export function sumDataUrlBytes(urls: readonly string[]): number {
  let total = 0;
  for (const u of urls) total += estimateDataUrlBytes(u);
  return total;
}
